import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cseBanner = {
  columnGap: css`var(--cse-banner-column-gap, ${csSpacing.spacing10})`,
  columnGapMobile: css`var(--cse-banner-column-gap-mobile, ${csSpacing.spacing05})`,
  textGap: css`var(--cse-banner-text-gap, ${csSpacing.spacing05})`,
  paddingBlock: css`var(--cse-banner-padding-y, ${csSpacing.spacing05})`,
  paddingInline: css`var(--cse-banner-padding-x, ${csSpacing.spacing06})`,

  primaryBackgroundColor: css`var(--cse-banner-primary-background-color, ${csColorAction.primary})`,
  primaryColor: css`var(--cse-banner-primary-color, ${csColorText.white})`,
  secondaryBackgroundColor: css`var(--cse-banner-secondary-background-color, ${csColorAction.secondary})`,
  secondaryColor: css`var(--cse-banner-secondary-color, ${csColorText.white})`,
  infoBackgroundColor: css`var(--cse-banner-info-background-color, ${csColorFunctional.info})`,
  infoColor: css`var(--cse-banner-info-color, ${csColorText.white})`,
  successBackgroundColor: css`var(--cse-banner-success-background-color, ${csColorFunctional.success})`,
  successColor: css`var(--cse-banner-success-color, ${csColorText.white})`,
  errorBackgroundColor: css`var(--cse-banner-error-background-color, ${csColorFunctional.error})`,
  errorColor: css`var(--cse-banner-error-color, ${csColorText.white})`,
  warningBackgroundColor: css`var(--cse-banner-warning-background-color, ${csColorFunctional.warning})`,
  warningColor: css`var(--cse-banner-warning-color, ${csColorText.white})`,
}

export const style: CSSResult = css`
  .cse-banner {
    padding-block: ${cseBanner.paddingBlock};
    padding-inline: ${cseBanner.paddingInline};
    width: 100%;

    @media(min-width: ${SCREENS.medium}) {
      display: flex;
      justify-content: space-around;
    }
  }

  .content {
    display: flex;
    justify-content: space-between;
    column-gap: ${cseBanner.columnGapMobile};

    @media(min-width: ${SCREENS.medium}) {
      align-items: center;
      column-gap: ${cseBanner.columnGap};
    }
  }

  .inner {
    display: flex;
    gap: ${cseBanner.textGap};
    align-items: baseline;
  }

  .text-content {
    --cse-link-primary-color-hover: ${csColorText.white};
    display: flex;
    gap: ${cseBanner.textGap};
    flex-direction: column;

    @media(min-width: ${SCREENS.medium}) {
      flex-direction: row;
    }
  }

  .variant-primary {
    --cse-text-color: ${cseBanner.primaryColor};
    --cse-link-primary-color: ${cseBanner.primaryColor};
    --cse-icon-button-ghost-color: ${cseBanner.primaryColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.primaryColor};
    background: ${cseBanner.primaryBackgroundColor};
  }

  .variant-primary .content {
    color: ${cseBanner.primaryColor};
  }

  .variant-secondary {
    --cse-text-color: ${cseBanner.secondaryColor};
    --cse-link-primary-color: ${cseBanner.secondaryColor};
    --cse-icon-button-ghost-color: ${cseBanner.secondaryColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.secondaryColor};
    background: ${cseBanner.secondaryBackgroundColor};
  }

  .variant-secondary .content {
    color: ${cseBanner.secondaryColor};
  }

  .variant-error {
    --cse-text-color: ${cseBanner.errorColor};
    --cse-link-primary-color: ${cseBanner.errorColor};
    --cse-icon-button-ghost-color: ${cseBanner.errorColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.errorColor};
    background: ${cseBanner.errorBackgroundColor};
  }

  .variant-error .content {
    color: ${cseBanner.errorColor};
  }

  .variant-info {
    --cse-text-color: ${cseBanner.infoColor};
    --cse-link-primary-color: ${cseBanner.infoColor};
    --cse-icon-button-ghost-color: ${cseBanner.infoColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.infoColor};
    background: ${cseBanner.infoBackgroundColor};
  }

  .variant-info .content {
    color: ${cseBanner.infoColor};
  }

  .variant-success {
    --cse-text-color: ${cseBanner.successColor};
    --cse-link-primary-color: ${cseBanner.successColor};
    --cse-icon-button-ghost-color: ${cseBanner.successColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.successColor};
    background: ${cseBanner.successBackgroundColor};
  }

  .variant-success .content {
    color: ${cseBanner.successColor};
  }

  .variant-warning {
    --cse-text-color: ${cseBanner.warningColor};
    --cse-link-primary-color: ${cseBanner.warningColor};
    --cse-icon-button-ghost-color: ${cseBanner.warningColor};
    --cse-icon-button-ghost-color-hover: ${cseBanner.warningColor};
    background: ${cseBanner.warningBackgroundColor};
  }

  .variant-warning .content {
    color: ${cseBanner.warningColor};
  }
`
